import {useCallback} from 'react'
import {useI18n} from '../../../i18n/I18nContext'

/** Union workspace translation helpers. English output is unchanged: `term`
 * returns backend enum values verbatim (or spaced) when no translation exists. */
export function useUnionI18n(){
 const {t,locale}=useI18n()
 const term=useCallback((value:unknown,raw=false)=>{
  const text=String(value??''),key=text.replace(/_/g,' '),translated=t(key)
  return translated!==key?translated:raw?text:key
 },[t])
 // English keeps the browser's default formatting used before localization.
 const intl=locale==='en'?undefined:locale
 const dateTime=useCallback((value:string|number|Date)=>new Date(value).toLocaleString(intl),[intl])
 const date=useCallback((value:string|number|Date)=>new Date(value).toLocaleDateString(intl),[intl])
 return {t,term,dateTime,date,locale}
}
